/**
 * Frontend build metadata, injected at build time via `define` in
 * vite.config.ts (see also vitest.config.ts for the test values).
 * `typeof` guards keep non-Vite runners (jest) from throwing ReferenceError.
 */
export const APP_VERSION: string =
  typeof __APP_VERSION__ !== 'undefined' ? __APP_VERSION__ : '0.0.0';

export const GIT_SHA: string =
  typeof __GIT_SHA__ !== 'undefined' ? __GIT_SHA__ : 'dev';

export const BUILD_TIME: string =
  typeof __BUILD_TIME__ !== 'undefined' ? __BUILD_TIME__ : '';

const NOT_COMPARABLE = new Set(['', 'dev', 'unknown', 'none']);

/**
 * True only when both sides expose a real commit sha and they refer to
 * different commits. Short-vs-long shas are treated as equal when one is a
 * prefix of the other. Placeholder values ('dev', 'unknown', empty) make the
 * comparison inconclusive → false (no false-alarm indicator).
 */
export function isBuildMismatch(
  frontendSha: string | undefined,
  backendSha: string | undefined
): boolean {
  const fe = (frontendSha || '').trim().toLowerCase();
  const be = (backendSha || '').trim().toLowerCase();
  if (NOT_COMPARABLE.has(fe) || NOT_COMPARABLE.has(be)) return false;
  if (!/^[0-9a-f]{7,40}$/.test(fe) || !/^[0-9a-f]{7,40}$/.test(be))
    return false;
  return !(fe.startsWith(be) || be.startsWith(fe));
}
